import { useEffect, useState } from 'react';
import Image from 'next/image';
import plavedLogo from '../../Assets/images/plavedLogo.png';

const SplashScreen = ({ onComplete }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    // Hide splash after a short delay
    const timer = setTimeout(() => {
      setShow(false);
      if (onComplete) {
        setTimeout(onComplete, 300); // Wait for fade out animation
      }
    }, 1500); // Show for 1.5 seconds

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!show) return null;

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-white transition-opacity duration-300 ${
        show ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="flex flex-col items-center">
        <Image
          src={plavedLogo}
          width={200}
          height={80}
          alt="PLAVED"
          priority
          className="w-48 h-auto"
        />
        <div className="mt-8">
          <div className="h-1 w-32 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-plaved rounded-full animate-[loading_1.5s_ease-in-out]" />
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes loading {
          from {
            width: 0%;
          }
          to {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;